import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IdleService } from 'src/app/admin/services/idle.service';

declare var $: any;

@Injectable()
export class AppInterceptor implements HttpInterceptor {
    constructor( private spinner: NgxSpinnerService, public router: Router,private _snackBar: MatSnackBar,private idleService: IdleService) {}
  
    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 

  // var url = window.location.href;
  // var arr = url.split("/");

       let token = '';

      let loginToken = localStorage.getItem('loginToken');
     
      if (loginToken !== null) {
        token = 'Bearer '+loginToken;
      } else {
        token = 'Bearer ';
       
      }
      
      req = req.clone({ 
        setHeaders: {
        'Accept': 'application/json',
        'X-Content-Security-Policy':'script-src "self"',
        'X-Frame-Options': 'DENY',
        'X-Content-Type-Options':'nosniff',
        'X-XSS-Protection':' 1; Mode=block',
        'Authorization': token,
        // 'Origin': arr[0] + "//" + arr[2],
        // 'Access-Control-Allow-Origin':arr[0] + "//" + arr[2],
        // 'Referrer Policy':'strict-origin-when-cross-origin'
        }
        });

        
       
        this.spinner.show();

        return next.handle(req).pipe(map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.spinner.hide();
            }
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            this.spinner.hide();
            const started = Date.now();            
            
            //  if(error.status == 500){
            //   this.router.navigateByUrl("/console/error")
            //  }            
            if(error.status  == 402 || error.status == 500){
              localStorage.clear();
              this.idleService.clearIntercepterAlert.next(true);
              $('.modal').modal('hide');
              $('.modal-backdrop').remove();
              this.router.navigateByUrl("/");
              this._snackBar.open(error.error.message, "", { duration: 5000 });
             }
             else{
            return throwError(error);
             }
          })
        );

    } 
    
  //    getKeyValues(data) {
  //     var q = [];
  //     var keys = Object.keys(data);
  //     for (var i = 0; i < keys.length; i++) {
  //         var key = keys[i];
  //         var value = data[key];
  //         if (value == null) {
  //             q.push(key + "=''");
  //         } else if (typeof value == "object") {
  //             q.push(this.getKeyValues(value));
  //         } else {
  //             q.push(value);
  //         }
  //     }
  //     return q.join(",");
  // }
}